module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David L. Golemon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("DAVID L. GOLEMON grew up in Chino, California.  He has raised three great children and now makes his home in New York. "), _c('I', [_vm._v("The Mountain ")]), _vm._v("is the tenth novel in his Event Group Series.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/143QLTd/images/9781466861428.jpg?1718183453093",
      "alt": "This image is the cover for the book Mountain, Event Group Thrillers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mountain, Event Group Thrillers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Experience the first mission of the US government’s most secret agency as Civil War–era agents are tasked with retrieving a mythical artifact.")]), _c('br'), _c('br'), _vm._v("It’s 1863. America’s most legendary war leaders arrange a meeting—a clandestine alliance that will never show up in any history book. Their mission: To heal a war-torn nation by bringing the remnants of a prized ship back to US soil—one that may lie on a mountaintop inside the Ottoman Empire, where the men who seek it are only days away from killing one another. The battles will rage at sea and upon land—with enemies both past and future. Colonel John Henry Thomas of the Union Army will come face to face with his mortal enemies in the South and a dark entity that has been trapped on top of God’s Mountain for a millennium."), _c('br'), _c('br'), _vm._v("In 2007, America’s darkest agency, known to only a privileged few as the Event Group, recruits a man they desperately need for their security. Major Jack Collins is brought to the underground world of the organization to learn about the darkest secrets in history, and is told a tale that brings him full circle on why his destiny has always lain with Department 5656 . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0